export default __webpack_public_path__ + "static/22-bdc158e90a5eec8a71975949f28e9805.jpg";